import { render, staticRenderFns } from "./PlatformSupported.vue?vue&type=template&id=e1073070&scoped=true&"
import script from "./PlatformSupported.vue?vue&type=script&lang=js&"
export * from "./PlatformSupported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1073070",
  null
  
)

export default component.exports